import { useTranslation } from 'react-i18next';

import { cardNamedImage, cardAnonymImage, cardSeveralUserImage } from '@treezor/design-system';

import { IBulkCard } from '@/features/cards/store/models/bulk-card.model';

interface ICardCreationDetailLeftSideProps {
  bulkCardCreation: IBulkCard;
}

export const CardCreationDetailLeftSide = ({ bulkCardCreation }: ICardCreationDetailLeftSideProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="typo-body-bold-paragraphLarge text-secondary ml-4 mb-2">
        {t('pages.administration.bulkCards.creationDetails.title')}
      </p>
      <div className="relative w-full">
        <img
          src={
            bulkCardCreation && bulkCardCreation?.anonymous === 1
              ? cardAnonymImage
              : bulkCardCreation && bulkCardCreation?.userIdOwner
                ? cardNamedImage
                : cardSeveralUserImage
          }
        />
        <div className="absolute top-[15%] left-[12%] flex flex-col gap-1 text-onColor">
          <p className="typo-body-semibold-paragraph">
            {bulkCardCreation && bulkCardCreation?.medium === 1
              ? t('pages.administration.bulkCards.creationDetails.physicalCard')
              : t('pages.administration.bulkCards.creationDetails.virtualCard')}
          </p>
          <span className="typo-body-regular-caption">
            {bulkCardCreation && bulkCardCreation?.anonymous === 1
              ? t('pages.administration.bulkCards.creationDetails.anonymous')
              : bulkCardCreation && bulkCardCreation?.userIdOwner
                ? t('pages.administration.bulkCards.creationDetails.userId') + bulkCardCreation?.userIdOwner
                : t('pages.administration.bulkCards.creationDetails.severalId')}
          </span>
        </div>
      </div>
    </div>
  );
};
